import React, { useEffect, useRef, useState } from 'react'
import { HamburgerIcon, SearchIcon } from '@chakra-ui/icons';
import {
    AlertDialog, AlertDialogBody, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogOverlay, Avatar, Badge, Box, Breadcrumb, BreadcrumbItem, BreadcrumbLink, Button, Card, CardBody, Checkbox, Flex, FormControl, FormLabel, Heading, IconButton, Image, Input, InputGroup, InputLeftElement, Menu, MenuButton, MenuItem, MenuList, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Select, SimpleGrid, Skeleton, SkeletonCircle, Stack, Switch, Table, TableCaption, TableContainer, Tbody, Td, Text, Tfoot, Th, Thead, Tooltip, Tr, useColorModeValue, useDisclosure, useToast, Portal, Popover, PopoverTrigger, PopoverContent, PopoverArrow, PopoverBody, InputRightElement, CloseButton
} from '@chakra-ui/react'
import { useTranslation } from 'react-i18next';
import { PiPlusBold } from 'react-icons/pi';
import { useNavigate } from 'react-router-dom'
import { FiEdit3 } from 'react-icons/fi';
import { MdGroupRemove } from 'react-icons/md';
import BulkStatusUpdateModal from '../../../../components/BulkStatusUpdateModal';
import { LiaUserEditSolid } from 'react-icons/lia';
import { useStateContext } from '../../../../context/ContextProvider';
import axiosClient from '../../../../axios-client';
import { TbListDetails } from 'react-icons/tb';
import { RiDeleteBinLine, RiFileTransferLine } from 'react-icons/ri';
import MyPagination from '../../../../components/MyPagination';
import { IoIosCheckmark } from 'react-icons/io';
import './Style.css'
import { RiFileExcel2Fill } from "react-icons/ri";
import { FaCloudArrowDown, FaRegEye } from "react-icons/fa6";
import { LuTextCursorInput } from "react-icons/lu";
import ProgressBar from '@ramonak/react-progress-bar';
import { AsyncPaginate } from 'react-select-async-paginate';
import { DateRange } from 'react-date-range';
import format from 'date-fns/format';
import fr from 'date-fns/locale/fr';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { GrPowerReset } from 'react-icons/gr';



let isFirstLoad_New_Commandes = true;
function New_Commandes() {
    const navigate = useNavigate()
    const { t } = useTranslation();
    const { user, setUser, setToken, dataSubscriptionUser, getAbonnementClient, currentBusiness } = useStateContext();
    const toast = useToast()

    const [confirmUsers, setConfirmUsers] = useState([])
    const [dataOrders, setDataOrders] = useState([])
    const [paginationData, setPaginationData] = useState([])

    const [searchTerm, setSearchTerm] = useState('');
    const [userSelected, setUserSelected] = useState('');

    const [dateDebutValue, setDateDebutValue] = useState("");
    const [dateFinValue, setDateFinValue] = useState("");

    const [selectionRange, setSelectionRange] = useState({
        startDate: new Date(),
        endDate: new Date(),
        key: 'selection',
    });

    const handleSelectDateRange = (ranges) => {
        const { startDate, endDate } = ranges.selection;
        setSelectionRange(ranges.selection);
        setDateDebutValue(format(startDate, 'yyyy-MM-dd'));
        setDateFinValue(format(endDate, 'yyyy-MM-dd'));
    };

    const clearDateRange = () => {
        setDateDebutValue("");
        setDateFinValue("");
        setSelectionRange({
            startDate: new Date(),
            endDate: new Date(),
            key: 'selection',
        });
    };

    const [selectedProduct, setSelectedProduct] = useState(null);

    const [loading, setLoading] = useState(true)

    const [userConfirmationSelected, setUserConfirmationSelected] = useState()

    const fetchUsers = async () => {
        try {
            await axiosClient.get(`/clients/getClientUsers/?id=${user.id}&role=RespoSuiviClient&page_size=100&business=${currentBusiness?.id}`).then(res => {
                setConfirmUsers(res.data.results)
                // console.log('Confirmation users ll : ', res.data);
            })
        } catch (error) {
            // console.log('ERROR : ', error);
            setLoading(false)
        }
    }




    // PAGINATION

    const [currentPage, setCurrentPage] = useState(0);

    ////////////////////////////////the size of the table//////////////////////////////
    const PAGE_SIZE = 10;
    const [pageSize, setPageSize] = useState(PAGE_SIZE);
    const handlePageSizeChange = (event) => {
        const newSize = parseInt(event.target.value, 10);
        setPageSize(newSize);
        setCurrentPage(0);
    };

    const fetchData = async (pageSize, currentPage, searchTerm, userSelected, dateDebutValue, dateFinValue, productSelected) => {
        try {
            setLoading(true)
            await axiosClient.get(`/commandes/getNewOrders/?clientId=${user.id}&userSelected=${userSelected}&page_size=${pageSize}&page=${currentPage + 1}&search_term=${searchTerm}&dateDebut=${dateDebutValue}&dateFin=${dateFinValue}&product=${productSelected ? productSelected.value : ''}&business=${currentBusiness?.id}`, { hideLoader: !isFirstLoad_New_Commandes }).then(res => {
            isFirstLoad_New_Commandes = false;

                if (res.data.length !== 0) {
                    setDataOrders(res.data.results)
                    setPaginationData(res.data)
                } else {
                    setDataOrders([])
                    setPaginationData([])
                }

                if (res.data.error === 'Client is disabled.' && res.data.etat === false) {
                    setUser({});
                    setToken(null);
                    localStorage.removeItem("tokenExpirationTime");
                    localStorage.removeItem("refreshTimeAdmin");
                    localStorage.removeItem("role");

                    // Vérifier si le toast n'est pas déjà affiché
                    if (!toast.isActive('accountDisabled')) {
                        toast({
                            id: 'accountDisabled',
                            description: t("le compte est désactivé"),
                            status: 'warning',
                            variant: 'left-accent',
                            duration: 2000,
                            isClosable: true,
                            position: 'bottom-right'
                        });
                    }
                }
            })
            setLoading(false)
        } catch (error) {
            // console.log('ERROR : ', error);
            setLoading(false)
        }
    }

    useEffect(() => {
        if (user?.id) {
            ["AdminClient", "ManagerClient"].includes(user.role) && fetchUsers()
            fetchData(pageSize, currentPage, searchTerm, userSelected, dateDebutValue, dateFinValue, selectedProduct)
        }
    }, [user?.id, currentPage, searchTerm, pageSize, userSelected, dateDebutValue, dateFinValue, selectedProduct])


    // État pour stocker les lignes sélectionnées
    const [selectedRows, setSelectedRows] = useState([]);

    // Fonction pour gérer le clic sur la case à cocher
    const handleCheckboxClick = (index) => {
        // Vérifie si la ligne est déjà sélectionnée
        const selectedIndex = selectedRows.indexOf(index);
        if (selectedIndex === -1) {
            // Si la ligne n'est pas déjà sélectionnée, l'ajouter à l'état
            setSelectedRows([...selectedRows, index]);
        } else {
            // Si la ligne est déjà sélectionnée, la retirer de l'état
            setSelectedRows(selectedRows.filter((rowIndex) => rowIndex !== index));
        }
    };

    const handleSelectAll = (e) => {
        if (e.target.checked) {
            setSelectedRows(dataOrders.map(order => order.id));
        } else {
            setSelectedRows([]);
        }
    };

    //Assign Order TO user    

    const [isAssignOrderOpen, setIsAssignOrderOpen] = useState(false);
    const assignOrderRef = React.useRef()
    const [userID, setUserID] = useState()
    const [orderID, setOrderID] = useState()

    const onOpenAssignOrder = (user, order) => {
        setIsAssignOrderOpen(true);
        setUserID(user)
        setOrderID(order)
    };
    const onCloseAssignOrder = () => {
        setIsAssignOrderOpen(false);
        setUserID()
        setOrderID()
    };

    const assignOrder = async () => {
        try {
            await axiosClient.patch(`/commandes/${orderID}/`, {
                assigned_to: userID
            }).then(res => {
                setDataOrders(dataOrders.map((val) => {
                    if (val.id === res.data.id) {
                        return {
                            ...val,
                            assigned_to: res.data.assigned_to
                        }
                    }
                    return val
                }))
                onCloseAssignOrder()
            })
        } catch (error) {
            // console.log('ERROR : ', error);
        }
    }

    //ASSIGN LIST of ORDERs to user

    const { isOpen, onOpen, onClose, onToggle } = useDisclosure()

    const assign_order_to = async (agentId) => {
        try {
            await axiosClient.post(`/commandes/bulk_actions/`, {
                action: 'assign',
                user_id: user.id,
                agent_id: agentId,
                order_ids: selectedRows
            }).then(res => {
                fetchData(pageSize, currentPage, searchTerm, userSelected, dateDebutValue, dateFinValue);
                toast({
                    description: t("Ordres attribués avec succès"),
                    status: 'success',
                    duration: 2000,
                    isClosable: true,
                    position: 'bottom-right'
                });
            });
        } catch (error) {
            // console.log('Error : ', error);
        }
        setUserConfirmationSelected()
        setSelectedRows([])
        onClose()
    }

    useEffect(() => {

        // console.log('check-subscription-status : ', dataSubscriptionUser);

    }, [dataSubscriptionUser])

    // DELETE

    const [isAlertOpen, setIsAlertOpen] = useState(false);
    const cancelRef = React.useRef()
    const [deletedId, setDeletedId] = useState()
    const [date_creation, setDate_creation] = useState()
    const [date_modification, setDate_modification] = useState()

    const onOpenAlert = (id, dateCreation, dateModification) => {
        setIsAlertOpen(true);
        setDeletedId(id)
        setDate_creation(dateCreation)
        setDate_modification(dateModification)
    };
    const onCloseAlert = () => {
        setIsAlertOpen(false);
        setDeletedId()
        setDate_creation()
        setDate_modification()
    };

    const DeleteArrayOfOrders = async () => {
        if (deletedId && deletedId !== null) {
            try {
                await axiosClient.patch(`commandes/${deletedId}/`, {
                    is_deleted: true
                }).then(res => {
                    if (
                        new Date(date_creation).getTime() < new Date(dataSubscriptionUser?.subscription?.end_date).getTime() &&
                        new Date(date_creation).getTime() >= new Date(dataSubscriptionUser?.subscription?.start_date).getTime()
                    ) {
                        axiosClient.patch(`client-subscriptions/${dataSubscriptionUser?.subscription?.id}/`, {
                            orders_count: parseInt(dataSubscriptionUser?.subscription?.orders_count) - 1
                        }).then(() => {
                            getAbonnementClient()
                        })
                    }
                    setDataOrders(dataOrders.filter(e => e.id !== deletedId))
                })
            } catch (error) {
                // console.log('ERROR : ', error);
            }
        }
        else {
            try {
                await axiosClient.post(`/commandes/bulk_actions/`, {
                    action: 'delete',
                    user_id: user.id,
                    order_ids: selectedRows
                }).then(res => {
                    fetchData(pageSize, currentPage, searchTerm, userSelected, dateDebutValue, dateFinValue);
                    getAbonnementClient();
                    toast({
                        description: t("Ordres supprimés avec succès"),
                        status: 'success',
                        duration: 2000,
                        isClosable: true,
                        position: 'bottom-right'
                    });
                });
            } catch (error) {
                // console.log('Error : ', error);
            }
            setSelectedRows([])
        }
        onCloseAlert()
    }

    // Update status


    const [statusConfirmation, setStatusConfirmation] = useState('')
    const [isModalEditStatusOpen, setIsModalEditStatusOpen] = useState(false);
    const ModalEditStatusRef = React.useRef()
    const [statusId, setStatusId] = useState()

    const onOpenModalEditStatus = (id) => {
        setIsModalEditStatusOpen(true);
        setStatusId(id)
    };
    const onCloseModalEditStatus = () => {
        setIsModalEditStatusOpen(false);
        setStatusConfirmation('')
        setStatusId()
    };

    const HandleChangeStatus = async () => {
        try {
            await axiosClient.patch(`commandes/${statusId}/`, {
                status_confirmation: statusConfirmation
            }).then((res) => {
                setDataOrders(dataOrders.filter(e => e.id !== statusId))
                onCloseModalEditStatus()
                toast({
                    description: t(`Statut est changé avec succès`),
                    status: 'success',
                    duration: 2000,
                    isClosable: true,
                    variant: 'left-accent',
                    position: 'bottom-right'
                })
            })
        } catch (error) {
            // console.log('ERROR : ', error);
        }
    }

    const borderColor = useColorModeValue("gray.300", "gray.600")
    const textSM = useColorModeValue('gray.400', 'gray.500')
    const bgPurple = useColorModeValue('purple.50', 'gray.600')

    const selectTextColor = useColorModeValue('black', 'white');
    const selectBg = useColorModeValue('transparent', 'transparent');
    const selectMenuBg = useColorModeValue('white', '#2D3748');
    const selectBorderColor = useColorModeValue('#E2E8F0', 'rgba(255, 255, 255, 0.16)');
    const selectHoverBg = useColorModeValue('#EDF2F7', '#4A5568');

    const resetFilters = () => {
        setSearchTerm('');
        setUserSelected('');
        clearDateRange();
        setSelectedProduct(null);
        setCurrentPage(0);
    };

    const loadProductOptions = async (search, loadedOptions, { page }) => {
        try {
            const res = await axiosClient.get(`/products/get_All_Products_names/?client=${user?.id}&page_size=20&page=${page}&search_term=${search}&userRole=${user?.role}&business=${currentBusiness?.id}`, { hideLoader: true });
            // console.log("res pour les produits : ", res);
            const results = res.data.results || [];
            const hasMore = res.data.next !== null && res.data.next !== undefined;

            return {
                options: results.map(product => ({
                    value: product.id,
                    label: product.title
                })),
                hasMore: hasMore,
                additional: {
                    page: page + 1,
                },
            };
        } catch (error) {
            // // console.error('Error fetching products', error);
            return { options: [], hasMore: false };
        }
    };

    const [showTitleAddManual, setShowTitleAddManual] = useState(false)
    const [showTitleAddExcel, setShowTitleAddExcel] = useState(false)
    const [showTitleAddApi, setShowTitleAddApi] = useState(false)

    const [activeMenu, setActiveMenu] = useState(false)
    const menuRef = useRef(null);

    // Function to handle clicks outside the menu
    const handleClickOutside = (event) => {
        if (menuRef.current && !menuRef.current.contains(event.target)) {
            setActiveMenu(false);
        }
    };

    useEffect(() => {
        // Add event listener for clicks outside
        document.addEventListener('mousedown', handleClickOutside);

        // Clean up event listener on component unmount
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);


    //vider l'input de date fin
    useEffect(() => {
        if (!dateDebutValue) {
            // Si dateDebutValue est vide, on réinitialise dateFinValue
            setDateFinValue('');
        } else if (dateFinValue && dateDebutValue >= dateFinValue) {
            // Si dateDebutValue est supérieur ou égal à dateFinValue, on réinitialise dateFinValue
            setDateFinValue('');
        }
    }, [dateDebutValue, dateFinValue]);

    // Aperçu Commande
    const [isPreviewOpen, setIsPreviewOpen] = useState(false);
    const [productsOrderData, setProductsOrderData] = useState([])
    const previewRef = React.useRef()
    const [previewId, setPreviewId] = useState()
    const [loadingPreview, setLoadingPreview] = useState(true)

    const onOpenPreview = async (id) => {
        setIsPreviewOpen(true);
        setLoadingPreview(true)
        await axiosClient.get(`/produitCommande/getProductsOrder/?commande=${id}&client_id=${user?.id}&userRole=${user?.role}`)
            .then((res) => {
                setProductsOrderData(res.data)

                if (res.data.error === 'Client is disabled.' && res.data.etat === false) {
                    setUser({});
                    setToken(null);
                    localStorage.removeItem("tokenExpirationTime");
                    localStorage.removeItem("refreshTimeAdmin");
                    localStorage.removeItem("role");

                    // Vérifier si le toast n'est pas déjà affiché
                    if (!toast.isActive('accountDisabled')) {
                        toast({
                            id: 'accountDisabled',
                            description: t("le compte est désactivé"),
                            status: 'warning',
                            variant: 'left-accent',
                            duration: 2000,
                            isClosable: true,
                            position: 'bottom-right'
                        });
                    }
                }
            })
            .catch((error) => {
                // console.log('ERROR : ', error)
                setLoadingPreview(false)
            })
            .finally(() => {
                setLoadingPreview(false)
            })
        setPreviewId(id)
    };
    const onClosePreview = () => {
        setIsPreviewOpen(false);
        setProductsOrderData([])
        setLoadingPreview(true)
        setPreviewId()
    };

    return (
        <Box position={"relative"} mb={5}>

            {
                // ["AdminClient", "ManagerClient"].includes(user.role) &&
                <Box ref={menuRef} className='boxMenu' zIndex={activeMenu ? 999 : 0} position={"fixed"} bottom={5} right={3}>
                    <Flex h={'100%'} flexDirection={"column"} justifyContent={'space-between'}>
                        {<Flex justifyContent='space-between'>
                            <Tooltip hasArrow label='Excel' fontSize='md'>
                                <Button
                                    className={`dispalyButtonsTopRight ${activeMenu && 'dispalyButtons'}`}

                                    onClick={() => {
                                        if (dataSubscriptionUser?.message === 'Client has no active subscription') {
                                            toast({
                                                description: t("Pas d'abonnement actif"),
                                                status: 'warning',
                                                duration: 2000,
                                                isClosable: true,
                                                variant: 'left-accent',
                                                position: 'bottom-right'
                                            })
                                            return
                                        }
                                        else if (dataSubscriptionUser?.subscription?.demande) {
                                            toast({
                                                description: t("Votre abonnement n'est pas encore accepté"),
                                                status: 'warning',
                                                duration: 2000,
                                                isClosable: true,
                                                variant: 'left-accent',
                                                position: 'bottom-right'
                                            })
                                            return
                                        }
                                        else if (!dataSubscriptionUser?.subscription?.is_active) {
                                            toast({
                                                description: t("Votre abonnement est désactivé"),
                                                status: 'warning',
                                                duration: 2000,
                                                isClosable: true,
                                                variant: 'left-accent',
                                                position: 'bottom-right'
                                            })
                                            return
                                        }
                                        else navigate("/NewOrderExcel")
                                    }}
                                    colorScheme='green'
                                >
                                    <RiFileExcel2Fill size={18} />
                                </Button>
                            </Tooltip>


                            <Tooltip hasArrow label='Api' fontSize='md'>
                                <Button
                                    className={`dispalyButtonsTopLeft ${activeMenu && 'dispalyButtons'}`}
                                    onClick={() => {
                                        if (dataSubscriptionUser?.message === 'Client has no active subscription') {
                                            toast({
                                                description: t("Pas d'abonnement actif"),
                                                status: 'warning',
                                                duration: 2000,
                                                isClosable: true,
                                                variant: 'left-accent',
                                                position: 'bottom-right'
                                            })
                                            return
                                        }
                                        else if (dataSubscriptionUser?.subscription?.demande) {
                                            toast({
                                                description: t("Votre abonnement n'est pas encore accepté"),
                                                status: 'warning',
                                                duration: 2000,
                                                isClosable: true,
                                                variant: 'left-accent',
                                                position: 'bottom-right'
                                            })
                                            return
                                        }
                                        else if (!dataSubscriptionUser?.subscription?.is_active) {
                                            toast({
                                                description: t("Votre abonnement est désactivé"),
                                                status: 'warning',
                                                duration: 2000,
                                                isClosable: true,
                                                variant: 'left-accent',
                                                position: 'bottom-right'
                                            })
                                            return
                                        }
                                        else navigate("/mes-apis")
                                    }}
                                    colorScheme='blue'
                                >
                                    <FaCloudArrowDown size={18} />

                                </Button>
                            </Tooltip>
                        </Flex>}

                        <Flex justifyContent='space-between'>

                            <Flex className={`dispalyButtonsLeft ${activeMenu && 'dispalyButtons'}`} justifyContent='space-between'>
                                <Tooltip hasArrow label='Manuel' fontSize='md'>
                                    <Button
                                        title={t('Ajouter la commande manuellement')}
                                        onClick={() => {
                                            if (dataSubscriptionUser?.message === 'Client has no active subscription') {
                                                toast({
                                                    description: t("Pas d'abonnement actif"),
                                                    status: 'warning',
                                                    duration: 2000,
                                                    isClosable: true,
                                                    variant: 'left-accent',
                                                    position: 'bottom-right'
                                                })
                                                return
                                            }
                                            else if (dataSubscriptionUser?.subscription?.demande) {
                                                toast({
                                                    description: t("Votre abonnement n'est pas encore accepté"),
                                                    status: 'warning',
                                                    duration: 2000,
                                                    isClosable: true,
                                                    variant: 'left-accent',
                                                    position: 'bottom-right'
                                                })
                                                return
                                            }
                                            else if (!dataSubscriptionUser?.subscription?.is_active) {
                                                toast({
                                                    description: t("Votre abonnement est désactivé"),
                                                    status: 'warning',
                                                    duration: 2000,
                                                    isClosable: true,
                                                    variant: 'left-accent',
                                                    position: 'bottom-right'
                                                })
                                                return
                                            }
                                            else navigate("/NewOrder")
                                        }}
                                        colorScheme='yellow'
                                    >
                                        <LuTextCursorInput size={18} />

                                    </Button>
                                </Tooltip>
                            </Flex>
                            <Button

                                onClick={() => {
                                    if (["AdminClient", "ManagerClient"].includes(user.role)) {
                                        setActiveMenu(!activeMenu)
                                        return;
                                    } else if (user?.role === "RespoSuiviClient") {
                                        if (dataSubscriptionUser?.message === 'Client has no active subscription') {
                                            toast({
                                                description: t("Pas d'abonnement actif"),
                                                status: 'warning',
                                                duration: 2000,
                                                isClosable: true,
                                                variant: 'left-accent',
                                                position: 'bottom-right'
                                            })
                                            return
                                        }
                                        else if (dataSubscriptionUser?.subscription?.demande) {
                                            toast({
                                                description: t("Votre abonnement n'est pas encore accepté"),
                                                status: 'warning',
                                                duration: 2000,
                                                isClosable: true,
                                                variant: 'left-accent',
                                                position: 'bottom-right'
                                            })
                                            return
                                        }
                                        else if (!dataSubscriptionUser?.subscription?.is_active) {
                                            toast({
                                                description: t("Votre abonnement est désactivé"),
                                                status: 'warning',
                                                duration: 2000,
                                                isClosable: true,
                                                variant: 'left-accent',
                                                position: 'bottom-right'
                                            })
                                            return
                                        }
                                        else navigate("/NewOrder")
                                    }
                                    // navigate("/NewOrder")
                                }}
                                colorScheme='purple'
                            >
                                <PiPlusBold className={`menu ${activeMenu && "active-menu"}`} size={18} />

                            </Button>
                        </Flex>
                    </Flex>
                </Box>
            }




            <Flex>
                <Box w="100%" display={"flex"} justifyContent="space-between" flexDirection={{ base: 'column', md: "row" }} mt={2} mb={{ base: 0, md: 5 }}>
                    <Breadcrumb fontFamily='Plus Jakarta Display' fontStyle={"italic"} fontSize={{ base: "20px", sm: "25px", lg: "27px" }} color="gray">
                        <BreadcrumbItem>
                            <BreadcrumbLink onClick={() => navigate('/')}>{t("Accueil")}</BreadcrumbLink>
                        </BreadcrumbItem>


                        <BreadcrumbItem isCurrentPage>
                            <BreadcrumbLink>{t("Nouvelles commandes")}</BreadcrumbLink>
                        </BreadcrumbItem>
                    </Breadcrumb>

                    <Flex align="center" gap={5} direction="row" justify="end">

                        {
                            dataSubscriptionUser?.message === 'Client has no active subscription' ?
                                <Badge colorScheme='red'
                                    rounded="xl"
                                    title={t("Pas d'abonnement actif")}
                                    px={2}>
                                    {t("Pas d'abonnement actif")} !
                                </Badge>
                                :
                                dataSubscriptionUser?.subscription?.demande || !dataSubscriptionUser?.subscription?.is_active
                                    ?
                                    <>
                                        {dataSubscriptionUser?.subscription?.demande
                                            &&
                                            <Badge colorScheme='red'
                                                rounded="xl"
                                                title={t("Votre abonnement n'est pas encore accepté")}
                                                px={2}>
                                                {t("Abonnement en attente")}
                                            </Badge>}

                                        {!dataSubscriptionUser?.subscription?.demande && !dataSubscriptionUser?.subscription?.is_active
                                            &&
                                            <Badge colorScheme='red'
                                                rounded="xl"
                                                title={t("Votre abonnement est désactivé")}
                                                px={2}>
                                                {t("Abonnement désactivé")}
                                            </Badge>}
                                    </>
                                    :
                                    <Badge colorScheme={parseInt(dataSubscriptionUser?.subscription?.orders_count) === parseInt(dataSubscriptionUser?.orders_limit) ? 'red' : 'green'}
                                        rounded="xl"
                                        title={parseInt(dataSubscriptionUser?.subscription?.orders_count) === parseInt(dataSubscriptionUser?.orders_limit) ? t('Vous avez atteint la limite de commandes pour votre abonnement') : t("Nombre de commandes restantes")}
                                        px={2}>
                                        {dataSubscriptionUser?.subscription?.orders_count} / {dataSubscriptionUser?.orders_limit} {t('commandes')}
                                    </Badge>
                        }
                    </Flex>
                </Box>

            </Flex>

            <Flex
                px={2}
                py={5}
                mx={5}
                bg={useColorModeValue('white', 'gray.700')}
                rounded={"2xl"}
                mt={2}
                align={'center'}
                justify={'center'}

            >

                <Stack
                    w={'full'}
                    maxW='full'
                    rounded={'lg'}
                    mt={2}
                    px={{ base: 1, md: 5 }}
                >
                    <Flex align="center" gap={3} w="full" direction={{ base: 'column', lg: 'row' }} justify="space-between" mb={6}>
                        <Flex gap={3} w="full" direction={{ base: 'column', md: 'row' }} flexWrap="wrap">
                            {["AdminClient", "ManagerClient"].includes(user.role) &&
                                <Select 
                                    borderColor={borderColor} 
                                    borderRadius="xl" 
                                    size="md" 
                                    fontSize={{ base: 13, lg: 16 }} 
                                    w={{ base: '100%', md: '200px' }} 
                                    value={userSelected} 
                                    onChange={(e) => {
                                        setCurrentPage(0)
                                        setUserSelected(e.target.value)
                                    }}
                                >
                                    <option value="">{t("Tout les utilisateurs")}</option>
                                    {confirmUsers?.map((val, key) => (
                                        <option key={key} value={val.id}>{`${val.first_name} ${val.last_name}`}</option>
                                    ))}
                                </Select>
                            }

                            <Box w={{ base: '100%', md: '250px' }}>
                                <AsyncPaginate
                                    loadOptions={loadProductOptions}
                                    onChange={(option) => {
                                        setCurrentPage(0);
                                        setSelectedProduct(option);
                                    }}
                                    value={selectedProduct}
                                    isClearable
                                    placeholder={t('Filtrer par produit...')}
                                    noOptionsMessage={() => t("Aucun produit trouvé")}
                                    additional={{ page: 1 }}
                                    styles={{
                                        control: (provided) => ({
                                            ...provided,
                                            backgroundColor: selectBg,
                                            borderColor: selectBorderColor,
                                            color: selectTextColor,
                                            minHeight: '40px',
                                            borderRadius: '12px'
                                        }),
                                        menu: (provided) => ({
                                            ...provided,
                                            zIndex: 9999,
                                            backgroundColor: selectMenuBg,
                                            borderRadius: '12px'
                                        }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? selectHoverBg : 'transparent',
                                            color: selectTextColor
                                        }),
                                        singleValue: (provided) => ({
                                            ...provided,
                                            color: selectTextColor
                                        }),
                                        input: (provided) => ({
                                            ...provided,
                                            color: selectTextColor
                                        })
                                    }}
                                />
                            </Box>

                            <Box w={{ base: '100%', md: '300px' }}>
                                <Popover placement="bottom-start">
                                    <PopoverTrigger>
                                        <InputGroup size="md">
                                            <Input
                                                readOnly
                                                value={dateDebutValue ? `${dateDebutValue} ${t("au")} ${dateFinValue}` : t("Choisir une période")}
                                                cursor="pointer"
                                                rounded="xl"
                                                borderColor={borderColor}
                                                bg={useColorModeValue('white', 'gray.700')}
                                                _hover={{ borderColor: 'purple.400' }}
                                                _focus={{ borderColor: 'purple.500', boxShadow: 'none' }}
                                            />
                                            {dateDebutValue && (
                                                <InputRightElement w="auto" pr={2}>
                                                    <IconButton
                                                        variant="ghost"
                                                        size="sm"
                                                        icon={<CloseButton size="sm" />}
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            clearDateRange();
                                                        }}
                                                        aria-label={t("Effacer la date")}
                                                    />
                                                </InputRightElement>
                                            )}
                                        </InputGroup>
                                    </PopoverTrigger>
                                    <PopoverContent w="auto" p={0} border="none" shadow="2xl" zIndex={9999}>
                                        <PopoverArrow />
                                        <PopoverBody p={0}>
                                            <DateRange
                                                ranges={[selectionRange]}
                                                onChange={handleSelectDateRange}
                                                locale={fr}
                                                maxDate={new Date()}
                                                rangeColors={['#805AD5']}
                                            />
                                        </PopoverBody>
                                    </PopoverContent>
                                </Popover>
                            </Box>

                            <InputGroup size="md" w={{ base: '100%', md: '250px' }}>
                                <InputLeftElement pointerEvents='none'>
                                    <SearchIcon color="gray.400" />
                                </InputLeftElement>
                                <Input
                                    borderColor={borderColor}
                                    borderRadius="xl"
                                    placeholder={t("Recherche...")}
                                    value={searchTerm}
                                    onChange={(e) => {
                                        setCurrentPage(0)
                                        setSearchTerm(e.target.value)
                                    }}
                                    _focus={{ borderColor: 'purple.500', boxShadow: 'none' }}
                                />
                            </InputGroup>

                            <IconButton
                                icon={<GrPowerReset />}
                                onClick={resetFilters}
                                variant="outline"
                                colorScheme="purple"
                                rounded="xl"
                                aria-label={t("Réinitialiser")}
                                title={t("Réinitialiser les filtres")}
                            />
                        </Flex>
                    </Flex>


                    {selectedRows.length > 0 && (
                        <Flex
                            mb={4}
                            gap={{ base: 2, md: 3 }}
                            w="100%"
                            align={{ base: 'flex-start', md: 'center' }}
                            bg={bgPurple}
                            p={3}
                            rounded="md"
                            direction={{ base: 'column', sm: 'row' }}
                            flexWrap="wrap"
                        >
                            <Text fontWeight="bold" whiteSpace="nowrap">
                                {selectedRows.length} {t("sélectionné(s)")}
                            </Text>

                            <Flex gap={2} flexWrap="wrap" align="center">
                                {["AdminClient", "ManagerClient"].includes(user.role) ? (
                                    <Button size="sm" colorScheme="purple" onClick={onOpen}>
                                        {t("Attribuer au responsable")}
                                    </Button>
                                ) : (
                                    <Button size="sm" colorScheme="purple" onClick={() => assign_order_to(user.id)}>
                                        {t("M'attribuer la sélection")}
                                    </Button>
                                )}


                                {["AdminClient", "ManagerClient"].includes(user.role) && (
                                    <>

                                        {/* ── Bulk Status Update ── */}
                                        <BulkStatusUpdateModal
                                            statusField="status_confirmation"
                                            statusKey="status_confirmation"
                                            statusOptions={[
                                                { value: 'Nouveau', label: 'Nouveau' },
                                                { value: 'Pas de réponse', label: 'Pas de réponse' },
                                                { value: 'Messagerie vocale', label: 'Messagerie vocale' },
                                                { value: 'En attente', label: 'En attente' },
                                                { value: 'Ligne occupée', label: 'Ligne occupée' },
                                                { value: 'Mauvais numéro', label: 'Mauvais numéro' },
                                                { value: 'Annulé', label: 'Annulé' },
                                                { value: 'Confirmé', label: 'Confirmé' },
                                            ]}
                                            selectedRows={selectedRows}
                                            dataList={dataOrders}
                                            onSuccess={() => {
                                                fetchData(pageSize, currentPage, searchTerm, userSelected, dateDebutValue, dateFinValue);
                                                setSelectedRows([]);
                                            }}
                                        />

                                        <Button size="sm" colorScheme="red" onClick={() => onOpenAlert(null)}>
                                            {t("Supprimer la sélection")}
                                        </Button>
                                    </>
                                )}
                            </Flex>
                        </Flex>
                    )}

                    <TableContainer>
                        <Table variant='simple'>
                            {/* <TableCaption>Imperial to metric conversion factors</TableCaption> */}
                            <Thead>
                                <Tr>
                                    <Th borderBottomColor='gray.400'>
                                        <Checkbox
                                            size="md"
                                            colorScheme='purple'
                                            onChange={handleSelectAll}
                                            isChecked={selectedRows.length === dataOrders.length && dataOrders.length > 0}
                                        />
                                    </Th>
                                    <Th borderBottomColor='gray.400'>{t("#ID")}</Th>
                                    {["AdminClient", "ManagerClient"].includes(user.role) && <Th borderBottomColor='gray.400'>{t("Responsable")}</Th>}
                                    <Th borderBottomColor='gray.400'>{t("Client")}</Th>
                                    <Th borderBottomColor='gray.400'>{t("Adresse")}</Th>
                                    <Th borderBottomColor='gray.400'>{t("Téléphone")}</Th>
                                    <Th borderBottomColor='gray.400'>{t("Source")}</Th>
                                    <Th borderBottomColor='gray.400'>{t("Status")}</Th>
                                    <Th borderBottomColor='gray.400'>{t("Coupons")}</Th>
                                    <Th borderBottomColor='gray.400'>{t("Prix")}</Th>
                                    <Th borderBottomColor='gray.400'>{t("Date Création")}</Th>
                                    <Th borderBottomColor='gray.400'>{t("Date Modification")}</Th>
                                    {["AdminClient", "ManagerClient"].includes(user.role) && <Th borderBottomColor='gray.400'>{t("Options")}</Th>}
                                    {["RespoSuiviClient"].includes(user.role) && <Th borderBottomColor='gray.400'>{t("Attribuer")}</Th>}
                                    {["RespoSuiviClient"].includes(user.role) && <Th borderBottomColor='gray.400'>{t("Détails")}</Th>}
                                    {["RespoSuiviClient"].includes(user.role) && <Th borderBottomColor='gray.400'>{t("Aperçu")}</Th>}

                                </Tr>
                            </Thead>
                            <Tbody>
                                {loading ?
                                    <Tr>
                                        <Td> <Skeleton height='20px' /></Td>
                                        <Td> <Skeleton height='20px' /></Td>
                                        <Td> <Skeleton height='20px' /></Td>
                                        <Td> <Skeleton height='20px' /></Td>
                                        <Td> <Skeleton height='20px' /></Td>
                                        <Td> <Skeleton height='20px' /></Td>
                                        <Td> <Skeleton height='20px' /></Td>
                                        <Td> <Skeleton height='20px' /></Td>

                                    </Tr>
                                    :
                                    dataOrders.length > 0 ?
                                        dataOrders.map((val, key) => {
                                            return (
                                                <Tr key={key}>
                                                    <Td>
                                                        <Checkbox size="md" colorScheme='purple' _focus={"none"} _active={'none'}
                                                            onChange={() => handleCheckboxClick(val.id)}
                                                            isChecked={selectedRows.includes(val.id)} />
                                                    </Td>
                                                    <Td>
                                                        <Text>{val.code}</Text>
                                                    </Td>
                                                    {["AdminClient", "ManagerClient"].includes(user.role) && <Td>
                                                        {val.assigned_to ?
                                                            <Flex flexDirection="column">
                                                                <Text>{val.first_name}</Text>
                                                                <Text>{val.last_name}</Text>
                                                            </Flex>
                                                            :
                                                            <Text>-</Text>
                                                        }
                                                    </Td>}
                                                    <Td>
                                                        <Flex flexDirection={"column"}>
                                                            <Text fontWeight='semibold'>{val.full_name}</Text>
                                                            {val.email !== "undefined" && <Text fontSize='sm' color={textSM}>{val.email}</Text>}
                                                        </Flex>
                                                    </Td>
                                                    <Td>
                                                        <Flex flexDirection={"column"}>
                                                            <Text fontSize={'md'}>{val.pays}, {val.ville}</Text>
                                                            <Text fontSize={'sm'} color={textSM}>{val.address}</Text>
                                                        </Flex>
                                                    </Td>
                                                    <Td>
                                                        <a href={`https://wa.me/${val.tel}`} target='blank'>
                                                            {val.tel}
                                                        </a>
                                                    </Td>
                                                    <Td>
                                                        <Text>{val.sourceAPI}</Text>
                                                    </Td>
                                                    <Td>
                                                        <Badge colorScheme='blue'
                                                            rounded="xl"
                                                            px={2}
                                                            cursor={["AdminClient", "ManagerClient"].includes(user.role) && 'pointer'}
                                                            onClick={() => {
                                                                ["AdminClient", "ManagerClient"].includes(user.role) && onOpenModalEditStatus(val.id)
                                                            }}>
                                                            {t(`${val.status_confirmation}`)}
                                                        </Badge>
                                                    </Td>
                                                    <Td>
                                                        <Text textAlign='center'>
                                                            {val.coupon ? val.couponTitle : '-'}
                                                        </Text>
                                                    </Td>
                                                    <Td>
                                                        <Flex gap={1} alignItems="center">
                                                            <Text color={val?.coupon && 'gray.400'} fontSize={val?.coupon && 15} fontWeight='semibold' textDecoration={val?.coupon && 'line-through'}>{val?.price}</Text>
                                                            <Text h={"100%"} fontSize={12} >{currentBusiness?.order_currency}</Text>
                                                        </Flex>
                                                        {
                                                            val?.coupon &&
                                                            <Flex gap={1} alignItems="center">
                                                                <Text fontWeight='semibold'>{val?.priceWithCoupon}</Text>
                                                                <Text h={"100%"} fontSize={12} >{currentBusiness?.order_currency}</Text>
                                                            </Flex>
                                                        }
                                                    </Td>
                                                    <Td>
                                                        <Flex flexDirection="column">
                                                            <Text fontSize="sm" fontWeight="medium">{new Date(val.date_creation).toLocaleDateString()}</Text>
                                                            <Text fontSize="xs" color="gray.500">{new Date(val.date_creation).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</Text>
                                                        </Flex>
                                                    </Td>
                                                    <Td>
                                                        {val.date_modification ? (
                                                            <Flex flexDirection="column">
                                                                <Text fontSize="sm" fontWeight="medium">{new Date(val.date_modification).toLocaleDateString()}</Text>
                                                                <Text fontSize="xs" color="gray.500">{new Date(val.date_modification).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</Text>
                                                            </Flex>
                                                        ) : (
                                                            <Text fontSize="sm" color="gray.400">-</Text>
                                                        )}
                                                    </Td>
                                                    <Td>
                                                        {["AdminClient", "ManagerClient"].includes(user.role) ? <Menu>
                                                            <MenuButton
                                                                as={IconButton}
                                                                aria-label='Options'
                                                                icon={<HamburgerIcon />}
                                                                variant='outline'
                                                            />
                                                            <MenuList>
                                                                <MenuItem icon={<FaRegEye size={18} />} onClick={() => {
                                                                    onOpenPreview(val.id)
                                                                }}>
                                                                    {t("Aperçu")}
                                                                </MenuItem>
                                                                <MenuItem icon={<TbListDetails size={18} />} onClick={() => {
                                                                    navigate('/Detail-Gestion-confirmation', {
                                                                        state: {
                                                                            id: val.id,
                                                                            tel: val.tel
                                                                        }
                                                                    })
                                                                }}>
                                                                    {t("Détails")}
                                                                </MenuItem>
                                                                <MenuItem icon={<RiFileTransferLine size={18} />} onClick={() => {
                                                                    handleCheckboxClick(val.id)
                                                                    onOpen()
                                                                }}>
                                                                    {t("Attribuer")}
                                                                </MenuItem>
                                                                <MenuItem icon={<RiDeleteBinLine size={18} />} onClick={() => {
                                                                    onOpenAlert(val.id, val.date_creation, val.date_modification)
                                                                }}>
                                                                    {t("Supprimer")}
                                                                </MenuItem>
                                                            </MenuList>
                                                        </Menu>
                                                            :
                                                            <>
                                                                {!val.assigned_to ? <Button variant='outline' colorScheme={'purple'} onClick={() => { onOpenAssignOrder(user.id, val.id) }}>
                                                                    {t('Prends-la')}
                                                                </Button>
                                                                    :
                                                                    <Flex alignItems='center' gap={2}>
                                                                        <Avatar h={25} w={25} src={user.image} />
                                                                        <Flex flexDirection="column" justifyContent="center">
                                                                            <Text fontSize={12} fontWeight='semibold'>{user.first_name}</Text>
                                                                            <Text fontSize={12} fontWeight='semibold'>{user.last_name}</Text>
                                                                        </Flex>
                                                                    </Flex>
                                                                }
                                                            </>
                                                        }
                                                    </Td>
                                                    {["RespoSuiviClient"].includes(user.role) && <Td>
                                                        <Button colorScheme='blue' variant='outline' onClick={() => {
                                                            navigate('/Detail-Gestion-confirmation', {
                                                                state: {
                                                                    id: val.id,
                                                                    tel: val.tel
                                                                }
                                                            })
                                                        }}>
                                                            {t("Détails")}
                                                        </Button>
                                                    </Td>}
                                                    {["RespoSuiviClient"].includes(user.role) && <Td>
                                                        <Button colorScheme='green' variant='outline' onClick={() => {
                                                            onOpenPreview(val.id)
                                                        }}>
                                                            {t("Aperçu")}
                                                        </Button>
                                                    </Td>}
                                                </Tr>
                                            )
                                        })
                                        :
                                        <Tr>
                                            <Td colSpan={10}>
                                                <Text fontSize={16}>{t("Donnée introuvable")}</Text>
                                            </Td>
                                        </Tr>
                                }
                            </Tbody>
                        </Table>
                    </TableContainer>


                    {/* //////////////////////////////////////////Pagination////////////////////////////////////////// */}
                    {paginationData.length !== 0 && <Flex flexDirection={{ base: 'column', lg: "row" }} justify="space-between" align="center" w="100%">
                        <Box flex="1">
                            <MyPagination
                                paginationData={paginationData}
                                currentPage={currentPage}
                                setCurrentPage={setCurrentPage}
                                PAGE_SIZE={pageSize}
                            />
                        </Box>

                        <Select rounded={"md"} size={"sm"} w="70px" value={pageSize} onChange={handlePageSizeChange}>
                            <option value="10">10</option>
                            <option value="20">20</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                        </Select>
                    </Flex>}
                    {/* //////////////////////////////////////////Pagination////////////////////////////////////////// */}
                </Stack >
            </Flex >


            {/* Modal to assign order */}
            < Modal closeOnOverlayClick={false} isOpen={isOpen} onClose={() => {
                onClose()
                setSelectedRows([])
            }
            }>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>{t("Attribuer la commande")}</ModalHeader>
                    <ModalCloseButton />

                    <ModalBody pb={6}>
                        <Text>
                            {t("Ici, vous pouvez attribuer une commande spécifique à un responsable de confirmation.")}
                        </Text>

                        <Select
                            mt={3}
                            rounded='lg'
                            size={"sm"}
                            value={userConfirmationSelected}
                            onChange={e => setUserConfirmationSelected(e.target.value)}
                        >
                            <option value=''>{t("Responsable de confirmation")}</option>
                            {confirmUsers?.map((val, key) => {
                                return (
                                    <option key={key} value={val.id}>{`${val.first_name} ${val.last_name}`}</option>
                                )
                            })}
                        </Select>

                    </ModalBody>
                    <ModalFooter>
                        <Button colorScheme='yellow' size="sm" variant='outline' isDisabled={!userConfirmationSelected} mr={3} onClick={() => assign_order_to(userConfirmationSelected)}>
                            {t("Attribuer")}
                        </Button>
                        <Button onClick={() => {
                            onClose()
                            setSelectedRows([])
                        }} size="sm" >{t("Annuler")}</Button>
                    </ModalFooter>
                </ModalContent>
            </Modal >


            {/* Alert to Delete Order */}

            < AlertDialog
                isOpen={isAlertOpen}
                leastDestructiveRef={cancelRef}
                onClose={onCloseAlert}
            >
                <AlertDialogOverlay>
                    <AlertDialogContent>
                        <AlertDialogHeader fontSize='lg' fontWeight='bold'>
                            {t("Supprimer")}
                        </AlertDialogHeader>

                        <AlertDialogBody>
                            {t("êtes-vous sûr ? Vous ne pourrez pas annuler cette action ultérieurement.")}
                        </AlertDialogBody>

                        <AlertDialogFooter>
                            <Button ref={cancelRef} onClick={onCloseAlert}>
                                {t("Annuler")}
                            </Button>
                            <Button onClick={DeleteArrayOfOrders} colorScheme='red' ml={3}>
                                {t("Supprimer")}
                            </Button>
                        </AlertDialogFooter>
                    </AlertDialogContent>
                </AlertDialogOverlay>
            </AlertDialog >


            {/* Alert to Take Order */}

            < AlertDialog
                isOpen={isAssignOrderOpen}
                leastDestructiveRef={assignOrderRef}
                onClose={onCloseAssignOrder}
            >
                <AlertDialogOverlay>
                    <AlertDialogContent>
                        <AlertDialogHeader fontSize='lg' fontWeight='bold'>
                            {t("Attribuer")}
                        </AlertDialogHeader>

                        <AlertDialogBody>
                            {t("Voulez-vous gérer cette commande ?")}
                        </AlertDialogBody>

                        <AlertDialogFooter>
                            <Button ref={cancelRef} onClick={onCloseAssignOrder}>
                                {t("Annuler")}
                            </Button>
                            <Button onClick={assignOrder} colorScheme='green' variant='outline' ml={3}>
                                {t("Prendre")}
                            </Button>
                        </AlertDialogFooter>
                    </AlertDialogContent>
                </AlertDialogOverlay>
            </AlertDialog >



            {/* Alert to Update confirmation status */}

            < AlertDialog
                isOpen={isModalEditStatusOpen}
                leastDestructiveRef={ModalEditStatusRef}
                onClose={onCloseModalEditStatus}
            >
                <AlertDialogOverlay>
                    <AlertDialogContent>
                        <AlertDialogHeader fontSize='lg' fontWeight='bold'>
                            {t('Statut de confirmation')}
                        </AlertDialogHeader>

                        <AlertDialogBody>
                            <Text>
                                Ici, vous pouvez modifier le statut de confirmation.
                            </Text>

                            <Select
                                mt={3}
                                rounded='lg'
                                size={"sm"}
                                value={statusConfirmation}
                                onChange={e => setStatusConfirmation(e.target.value)}
                            >
                                <option value=''>{t('Statut de confirmation')}</option>
                                <option value='Pas de réponse'>{t('Pas de réponse')}</option>
                                <option value='Messagerie vocale'>{t('Messagerie vocale')}</option>
                                <option value='En attente'>{t('En attente')}</option>
                                <option value='Ligne occupée'>{t('Ligne occupée')}</option>
                                <option value='Mauvais numéro'>{t('Mauvais numéro')}</option>
                                <option value='Annulé'>{t('Annulé')}</option>
                                <option value='Confirmé'>{t('Confirmé')}</option>
                            </Select>
                        </AlertDialogBody>

                        <AlertDialogFooter>
                            <Button colorScheme='yellow' size="sm" variant='outline' isDisabled={!statusConfirmation} mr={3} onClick={HandleChangeStatus}>
                                Modifier
                            </Button>
                            <Button onClick={onCloseModalEditStatus} size="sm" >Annuler</Button>
                        </AlertDialogFooter>
                    </AlertDialogContent>
                </AlertDialogOverlay>
            </AlertDialog >


            {/* Preview Order */}
            < Modal closeOnOverlayClick={false} size={"2xl"} isOpen={isPreviewOpen} leastDestructiveRef={cancelRef} onClose={onClosePreview}>
                <ModalOverlay />
                <ModalContent maxHeight={'90%'}>
                    <ModalHeader>{t("Aperçu la commande")}</ModalHeader>
                    <ModalCloseButton />



                    <SimpleGrid px={{ base: 2, md: 10 }} overflowY={'auto'} mb={5} mt={2} templateColumns={{ base: 'repeat(auto-fill,minmax(250px,1fr))', md: 'repeat(auto-fill,minmax(200px,1fr))' }} spacing={7}>
                        {loadingPreview
                            ? <Skeleton marginTop={5} height='300px' borderRadius={10} />
                            : productsOrderData.map((val, key) => {
                                return (
                                    <Card key={key} mt={5} mb={5} rounded={"xl"} shadow="lg" borderWidth={1} borderColor={'gray.200'}>
                                        <CardBody p={0} m={0}>
                                            <Stack position={"relative"}>
                                                <Image
                                                    height={"200px"}
                                                    src={val.produit?.images[0]?.image}
                                                    alt='Image'
                                                    objectFit="cover"
                                                    roundedTop={"xl"}
                                                />
                                            </Stack>
                                            <Stack p={3} alignItems='start' mt={2}>
                                                <Heading fontSize={'xl'} fontFamily={'body'} fontWeight={500}>
                                                    {val.produit?.title}
                                                </Heading>
                                                {/* <Text lineHeight={5} textAlign={'justify'} color={'descColor'}>
                                            {val.produit?.description}
                                        </Text> */}

                                                <Flex justifyContent="space-between" w='full'>
                                                    {val.color && <Flex gap={2}>
                                                        <Text color='gray'>{t('Couleur')} :</Text>
                                                        <Text fontWeight='semibold'>{val.color}</Text>
                                                    </Flex>}
                                                    {val.size && <Flex gap={2}>
                                                        <Text color='gray'>{t('Taille')} :</Text>
                                                        <Flex gap={1}>
                                                            <Text fontWeight='semibold'>{val.size}</Text>
                                                        </Flex>
                                                    </Flex>}
                                                </Flex>

                                                <Flex justifyContent="space-between" w='full'>
                                                    <Flex gap={2}>
                                                        <Text color='gray'>{t('Qté')} :</Text>
                                                        <Text fontWeight='semibold'>{val.quantity}</Text>
                                                    </Flex>
                                                    <Flex gap={2}>
                                                        <Text color='gray'>{t('Prix')} :</Text>
                                                        <Flex gap={1}>
                                                            <Text fontWeight='semibold'>{val.price}</Text>
                                                            <Text fontWeight='gray' fontSize={13}></Text>
                                                        </Flex>
                                                    </Flex>
                                                </Flex>

                                            </Stack>
                                        </CardBody>
                                    </Card>
                                )
                            })}

                    </SimpleGrid>

                </ModalContent>
            </Modal >

        </Box >
    )
}

export default New_Commandes